import Icon from "../icon/icon"

export default (props) => 
<div style={{display:"flex", gap: "8px", alignItems: "baseline"} }>
    <p className={`text lead bold ${props.className} `} style={{display:"flex", gap: "8px"}}><Icon icon={props.icon}/>{props.title}</p>
</div>